import {connect} from "react-redux";
import ApprovedList from "./ApprovedList";
import {bindActionCreators} from "redux";
import {approvedListingForDealer} from "../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    fetchDealerApprovalResponse:state.Dealer.fetchDealerApprovalResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            approvedListingForDealer
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ApprovedList);
